import { isSignedFileUrl, withStreamQuery } from '@shared/chat-media';
import { getStoredAccessToken } from './storage';

export type AuthorizedFetchFn = (input: string, init?: RequestInit) => Promise<Response>;

/**
 * Fetch a protected file URL as Blob (cookie session and/or Bearer token).
 * Pass `fetchFn` from the host adapter (e.g. api.authedFetch) for refresh-on-401.
 */
export async function fetchAuthorizedBlob(
  url: string,
  fetchFn?: AuthorizedFetchFn,
  opts?: { signal?: AbortSignal }
): Promise<Blob> {
  const streamUrl = withStreamQuery(url);
  const token = getStoredAccessToken();
  const perform = fetchFn ?? fetch;
  const signed = isSignedFileUrl(url);

  const res = await perform(streamUrl, {
    signal: opts?.signal,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: signed ? 'omit' : token ? 'same-origin' : 'include',
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  const blob = await res.blob();
  if (blob.size === 0) {
    throw new Error('Empty response body');
  }

  return blob;
}
